import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addParent = async (parent) => {
    return axios.post(`${BACKEND_URL}/parents`, parent);
};

export const getAllParents = async () => {
    return axios.get(`${BACKEND_URL}/parents`);
};

export const getParentsOfAthlete = async (email) =>{
    return axios.get(`${BACKEND_URL}/athletes/${email}/parents`);
};

export const updateAthletesOfParent = async (email, athletes) => {
    return axios.put(`${BACKEND_URL}/parents/${email}`, athletes);
};